import { gql } from "@apollo/client";
import { dateFormat } from "./helper";
export const typeDef = gql`
  type VoucherCode {
    id: ID
    code: String
    voucherId: Int
    validityStartAt: String
    validityEndAt: String
    expire_at: String
    isAvailable: Boolean
    voucher: Voucher
  }

  type Voucher {
    id: ID
    name: String
    description: String
    discountPrice: Int
    limitPrice: Int
    trialExtendTerm: Int
    trialExtendTermUnit: String
    trialExtendEndOf: String
    validityStartAt: String
    validityEndAt: String
  }
`;
export const resolvers = {
  VoucherCode: {
    id: v => v.voucher_code_id,
    voucherId: v => v.voucher_id,
    isAvailable: v => v.is_available,
    validityStartAt: v => dateFormat(v.validity_start_at),
    validityEndAt: v => dateFormat(v.validity_end_at)
  },
  Voucher: {
    id: v => v.voucher_id,
    discountPrice: v => v.discount_price,
    limitPrice: v => v.limit_price,
    trialExtendTerm: v => v.trial_extend_term,
    trialExtendTermUnit: v => {
      var _v$trial_extend_term_;
      return v === null || v === void 0 || (_v$trial_extend_term_ = v.trial_extend_term_unit) === null || _v$trial_extend_term_ === void 0 ? void 0 : _v$trial_extend_term_.split("_").slice(-1)[0];
    },
    trialExtendEndOf: v => {
      var _v$trial_extend_end_o;
      return v === null || v === void 0 || (_v$trial_extend_end_o = v.trial_extend_end_of) === null || _v$trial_extend_end_o === void 0 ? void 0 : _v$trial_extend_end_o.split("_").slice(-1)[0];
    },
    validityStartAt: v => dateFormat(v.validity_start_at),
    validityEndAt: v => dateFormat(v.validity_end_at)
  }
};